/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { debounce } from 'lodash';
import Form from 'src/components/Form/Form';
import { SportPopup } from 'src/components/SportPopup/SportPopup.tsx';
import { ActionDropdown } from 'src/components/ActionDropdown/ActionDropdown';
import CompetitionForm from 'src/components/CompetitionForm/CompetitionForm';
import config from 'src/config';
import { makeObservable } from 'mobx';
import { DateTimeRange } from 'src/components/DatetimeRangeInput/DateTimeRange';

//FIXME: Probably using https://www.npmjs.com/package/flat would be a better idea
function flat(data) {
    const result = {};

    Object.keys(data).forEach(key => {
        const value = data[key];

        if (value && typeof value === 'object') {
            Object.keys(value).forEach(k => {
                result[`${key }.${ k}`] = value[k];
            });
        }

        result[key] = value;
    });

    return result;
}

// @TODO: allow few values to be expanded at once
function expand(data) {
    const result = {};

    Object.keys(data).forEach(key => {
        const value = data[key];
        key = key.split('.');

        if (key.length === 1) {
            result[key[0]] = value;
        } else {
            result[key[0]] = {
                [key[1]]: value
            };
        }
    });

    return result;
}

function filter(obj, keys) {
    obj = Object.assign({}, obj);

    Object.keys(obj).forEach(key => {
        if (keys.indexOf(key) === -1) {
            delete obj[key];
        }
    });

    return obj;
}

function buildFormCallback(CustomForm, props) {
    props = props || {};

    return function (callback, data) {
        return (
            <CustomForm
                data={ flat(data && data.value && data.value.toJS ? data.value.toJS() : data && data.value || {}) }
                onSubmit={ (d) => callback(expand(d)) }
                { ...props }
            />
        );
    };
}

class TradingEventsFilters extends Form {
    static propTypes = {
        ...Form.propTypes,
        competitions: ImmutablePropTypes.list,
        sports: ImmutablePropTypes.map,
        countries: ImmutablePropTypes.map,
        competitionsStatus: PropTypes.string,

        onAddTagValueRequest: PropTypes.func.isRequired,
        onCreateCompetitionRequest: PropTypes.func.isRequired,
        onUpdateCompetitionRequest: PropTypes.func.isRequired,
        onLoadSportsRequest: PropTypes.func.isRequired,
        onLoadCompetitionsRequest: PropTypes.func.isRequired,
    };

    static defaultProps = {
        competitions: Map(),
        sports: Map(),
        countries: Map()
    };

    constructor( props, context ) {
        super( props, context );

        this.onSearchCompetitionThrottle = debounce( value => {
            const { onLoadCompetitionsRequest } = this.props;
            const { data: { sport } } = this.state;

            if ( onLoadCompetitionsRequest && value.length > 2 ) {
                onLoadCompetitionsRequest( {
                    ...(sport ? { sport } : {}),
                    [ 'name.ngram' ]: value
                } );
            }
        }, 700, { leading: false, trailing: true } );

        makeObservable(this);
    }

    closeSport() {
        this.setState({
            sportId: null
        });
    }

    onEditSport(sport) {
        this.setState({
            sportId: sport.id
        });
    }

    onEditCompetition(o, competition) {
        const { sports } = this.props;

        const id = competition.id;

        competition = filter(competition, [ 'name', 'sport', 'active', 'display' ]);

        competition.sport.name = sports.find(x => x.get('id') === competition.sport.id).get('name');

        this.props.onUpdateCompetitionRequest(id, competition);
    }

    onAddSport(sport) {
        console.log('Requested for adding sport', sport);
    }

    onAddCompetition(competition) {
        const { sports } = this.props;

        competition = filter(competition, [ 'name', 'sport', 'active', 'display' ]);

        competition.sport.name = sports.find(x => x.get('id') === competition.sport.id).get('name');
        this.props.onCreateCompetitionRequest(competition);
    }

    UNSAFE_componentWillMount() {
        // TODO: load sport in input for sport
        this.props.onLoadSportsRequest();
    }

    getFilters(data) {
        if (data.isEmpty()) {
            return null;
        }

        data = data.map(x => {
            return {
                id: x.get('id'),
                label: x.get('name'),
                value: x
            };
        }).sortBy(x => x.label).toArray();;

        return data;
    }

    countriesOptions(countries) {
        const data = countries.map(x => {
            return {
                id: x.id,
                name: x.name,
                label: x.name
            };
        });

        return data;
    }

    renderForm() {
        const { sports, competitionsStatus, competitions } = this.props;
        const { sportId } = this.state;
        const countries = this.countriesOptions(config.countries);
        const customFormCompetition = buildFormCallback(CompetitionForm, { sports });
        const filteredCompetitions = this.getFilters( competitions ) || [];
        const isLoadingCompetitions = competitionsStatus === 'IN_PROGRESS';

        return (
            <div className='row'>
                <SportPopup
                    id={ sportId }
                    onClose={ this.closeSport.bind(this)}
                />
                <div className='col-4'>
                    {
                        this.getField(
                            <DateTimeRange
                                {
                                    ...this.getFieldParameters('range')
                                }
                                onChange={ debounce(e => this.onChange('range', e), 300) }
                            />
                        )
                    }
                </div>
                <div className='col-2'>
                    {
                        this.getField(
                            <ActionDropdown
                                label='Sport'
                                className='dropdown-select-form select-has-add'
                                searchable={ true }
                                clearable={ true }
                                ignoreCase={ true }
                                options={ this.getFilters(sports) }
                                onEdit={ this.onEditSport.bind(this)}
                                onAdd={ this.onAddSport.bind(this)}
                                getAddForm={ () => 'Can\'t add sport (API needed)' }
                                isShorten={ true }
                                { ...this.getFieldParameters('sport') }
                            />
                        )
                    }
                </div>
                <div className='col-2'>
                    {
                        this.getField(
                            <ActionDropdown
                                label='Country'
                                /*options={ this.getFilters(countries) }
-                               onEdit={ this.onEditCountry.bind(this)}
-                               onAdd={ this.onAddCountry.bind(this)}
-                               getAddForm={ buildFormCallback(SimpleTagForm, { sports }) }
-                               getEditForm={ buildFormCallback(SimpleTagForm, { sports }) }*/

                                /*Get values from config file. Edit is disabled*/
                                options={ countries }
                                className='dropdown-select-form'
                                searchable={ true }
                                clearable={ true }
                                ignoreCase={ true }
                                addButton={ false }
                                isShorten={ false }
                                { ...this.getFieldParameters('country') }
                            />
                        )
                    }
                </div>
                <div className='col-2'>
                    {
                        this.getField(
                            <ActionDropdown
                                { ...this.getFieldParameters('competition') }
                                className='dropdown-select-form select-has-btn'
                                clearable={ true }
                                getAddForm={ customFormCompetition }
                                getEditForm={ customFormCompetition }
                                ignoreCase={ true }
                                noResultsText={
                                    isLoadingCompetitions ? 'Waiting for results' : 'No competitions found'
                                }
                                label='Select competition'
                                onAdd={ this.onAddCompetition.bind(this)}
                                onEdit={ this.onEditCompetition.bind(this)}
                                onInputChange={ this.onSearchCompetitionThrottle }
                                options={ filteredCompetitions }
                                searchable={ true }
                                searchPromptText='Type to search competition'
                                trimFilter={ true }
                                stopCustomFilter={ true }
                                isShorten={ true }
                            />
                        )
                    }
                </div>
                <div className='col-2'>
                    {
                        this.getField(
                            <input
                                type='text'
                                label='Search'
                                { ...this.getFieldParameters('q') }
                            />
                        )
                    }
                </div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default TradingEventsFilters;
